import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Trans, NumberFormat } from '@lingui/react';
import { connect } from 'react-redux';
import format from 'date-fns/format';
import cx from 'classnames';
import { selectors } from '../reducers/appReducer';
import {
    getCodiceArticolo,
    getCodiciInternazionali, getCurrencySymbol,
    getDescrizioneArticolo,
    getInizioValiditaPrezzo,
    getMarcaArticolo,
    getPrezzo, getPropLabel,
    getQtaContenuta,
    getStatus,
    getStatusCode,
    getUnitaContenuta,
    getUnitaOrdine, getUnitaPerPrezzo
} from './ArticleComponents/ArticleRecap/ArticleRecapUtils';

export class ArticleRecap extends Component {

    render() {

        // const currency = this.props.details?.prezzi[0]?.valuta ? this.props.details?.prezzi[0]?.valuta.value.code : 'EUR'
        // const currencySymbol = currenciesCodeISO[currency].symbol

        //const currencySymbol = getCurrencySymbol(this.props.details?.prezzi[0].valuta ? this.props.details.prezzi[0].valuta : null)

        const currencySymbol = getCurrencySymbol(
            this.props.details?.prezzi?.length ? this.props.details.prezzi[0].valuta : null
        )

        const price = getPrezzo(this.props.details, this.props.priceDecimalPrecision)


        const marca = getMarcaArticolo(this.props.details)
        const codiceArticolo = getCodiceArticolo(this.props.details)
        const codiciInternazionali = getCodiciInternazionali(this.props.details)
        const descrizioneArticolo = getDescrizioneArticolo(this.props.details)
        const unitaOrdine = getUnitaOrdine(this.props.details)
        const unitaPerPrezzo = getUnitaPerPrezzo(this.props.details)
        const unitaContenuta = getUnitaContenuta(this.props.details)
        const qtaContenuta = getQtaContenuta(this.props.details)
        const status = getStatus(this.props.details)

        return (
            <table className="table table-striped table-striped-alt table-hover table-article-recap mb-2">
                <tbody>
                    {marca && (
                        <tr>
                            <td>{getPropLabel('descrizione_marca', this.props.productProperties)}</td>
                            <td>
                                <strong>{marca}</strong>
                            </td>
                        </tr>
                    )}
                    {codiceArticolo && (
                        <tr>
                            <td>{getPropLabel('codice_articolo', this.props.productProperties)}</td>
                            <td>
                                <strong>{codiceArticolo}</strong>
                            </td>
                        </tr>
                    )}
                    {codiciInternazionali && (
                        <tr>
                            <td>{getPropLabel('codici_internazionali', this.props.productProperties)}</td>
                            <td>
                                <strong>{codiciInternazionali}</strong>
                            </td>
                        </tr>
                    )}
                    {descrizioneArticolo && (
                        <tr>
                            <td>{getPropLabel('descrizione_articolo', this.props.productProperties)}</td>
                            <td>
                                <strong dangerouslySetInnerHTML={{__html: descrizioneArticolo}} />
                            </td>
                        </tr>
                    )}
                    {price !== null && (
                        <tr>
                            <td>{getPropLabel('prezzo_listino', this.props.productProperties)}</td>
                            <td>
                                <strong>
                                    <span className="text-error">
                                        {currencySymbol}{' '}
                                        <NumberFormat
                                            value={price}
                                            format={{
                                                minimumFractionDigits:
                                                    this.props.priceDecimalPrecision,
                                                maximumFractionDigits:
                                                    this.props.priceDecimalPrecision,
                                            }}
                                        />{' '}
                                    </span>
                                    {getInizioValiditaPrezzo(this.props.details) && (
                                        <Fragment>
                                            <Trans id="from" />{' '}
                                            {format(getInizioValiditaPrezzo(this.props.details), 'DD/MM/YYYY')}
                                        </Fragment>
                                    )}
                                </strong>
                            </td>
                        </tr>
                    )}
                    {unitaOrdine && (
                        <tr>
                            <td>{getPropLabel('unita_ordine', this.props.productProperties)}</td>
                            <td>
                                <strong>{unitaOrdine}</strong>
                            </td>
                        </tr>
                    )}
                    {unitaPerPrezzo && (
                        <tr>
                            <td>{getPropLabel('unita_per_prezzo', this.props.productProperties)}</td>
                            <td>
                                <strong>{unitaPerPrezzo}</strong>
                            </td>
                        </tr>
                    )}
                    {unitaContenuta && (
                        <tr>
                            <td>{getPropLabel('unita_contenuta', this.props.productProperties)}</td>
                            <td>
                                <strong>{unitaContenuta}</strong>
                            </td>
                        </tr>
                    )}
                    {qtaContenuta && (
                        <tr>
                            <td>{getPropLabel('quantita_contenuta', this.props.productProperties)}</td>
                            <td>
                                <strong>{qtaContenuta}</strong>
                            </td>
                        </tr>
                    )}
                    {status && (
                        <tr>
                            <td>{getPropLabel('stato', this.props.productProperties)}</td>
                            <td>
                                <strong
                                    className={cx({
                                        'blink text-error': getStatusCode(this.props.details) === 'IV006650',
                                    })}
                                >
                                    {status}
                                </strong>
                            </td>
                        </tr>
                    )}
                    {/*{getMisure(this.props.details, this.props.productProperties)}*/}
                </tbody>
            </table>
        );
    }
}

ArticleRecap.propTypes = {
    item: PropTypes.object,
    details: PropTypes.object,
    language: PropTypes.string,
    productProperties: PropTypes.object,
};

function mapStateToProps(state) {
    return {
        priceDecimalPrecision: selectors.getPriceDecimalPrecision(state),
    };
}

export default connect(mapStateToProps)(ArticleRecap);
